import React from 'react';
import { Card } from '../../../components/Card/Card';

import { t } from '../../../locales/translate';
import { LabelledProgress } from '../../../components/LabelledProgress/LabelledProgress';
import { Tour } from '../../../model/tour';
import { Icon } from '../../../components/Icon/Icon';

interface Props {
  tour: Tour;
}

export function TourTicketDist({ tour }: Props): JSX.Element {
  const showTicketDist = tour.salesStats?.soldHard || tour.salesStats?.soldOnline || false;
  return (
    <section className="tour-overview__section">
      <Card
        title={t.model.ticket.soldTicketsDist}
        className="labelled-progress"
        actions={!tour.salesStats && <Icon name="ticket" loading />}
      >
        {tour.salesStats &&
          (showTicketDist ? (
            <LabelledProgress
              values={[
                {
                  value: tour.salesStats?.soldHard || 0,
                  label: t.model.ticket.hardticket,
                },
                {
                  value: tour.salesStats?.soldOnline || 0,
                  label: t.model.ticket.onlineticket,
                },
              ]}
            />
          ) : (
            <span>{t.model.ticket.noTicketsSold}</span>
          ))}
      </Card>
    </section>
  );
}
